import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { apiClient } from '../../../helpers/apiHelperV2';
import InlineSpinner from '../Spinner/InlineSpinner';
import ProductCard from '../layout/ProductCard';
import {
    vehicleManufacturerSelector,
    vehicleSelectionLabelSelector,
    vehicleDataSelector,
    showUniversalSelector,
} from '../../../modules/selectors/vehicle';
import Button from '../form-elements/Button';

const PAGE_SIZE = 10;

function VehicleSelectionProducts() {
    const standortUrl = useSelector(standortUrlSelector);
    const vehicleManufacturer = useSelector(vehicleManufacturerSelector);
    const vehicleData = useSelector(vehicleDataSelector);
    const showUniversal = useSelector(showUniversalSelector);
    const label = useSelector(vehicleSelectionLabelSelector);

    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const requestIdRef = useRef(0);

    const fetchPage = async (skip) => {
        const currentId = ++requestIdRef.current;
        setIsLoading(true);
        try {
            const response = await apiClient.post(
                `/api/v1/standorte/${standortUrl}/vehicleSelectionProducts`,
                {
                    marke: vehicleManufacturer,
                    vehicle: vehicleData,
                    showUniversal,
                    skip,
                    limit: PAGE_SIZE,
                }
            );
            if (currentId !== requestIdRef.current) return;
            const data = response?.data?.data ?? [];
            const newTotal = response?.data?.total ?? 0;
            setItems(prev => (skip === 0 ? data : [...prev, ...data]));
            setTotal(newTotal);
        } catch (err) {
            if (currentId !== requestIdRef.current) return;
            console.error('vehicleSelectionProducts fetch failed', err);
        } finally {
            if (currentId === requestIdRef.current) setIsLoading(false);
        }
    };

    useEffect(() => {
        requestIdRef.current++;
        setItems([]);
        setTotal(0);
        if (!vehicleData) return;
        fetchPage(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [standortUrl, vehicleManufacturer, vehicleData, showUniversal]);

    if (!vehicleData) return null;
    if (isLoading && items.length === 0) return <InlineSpinner />;

    const hasMore = items.length < total;

    return (
        <section className="uk-section uk-section-default uk-padding-remove-bottom">
            <div className="uk-container">
                <h3>{total} Artikel für folgendes Fahrzeug gefunden: {label}</h3>
                <div>
                    <ul className="uk-grid uk-grid-match uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-5@l uk-margin-remove-left">
                        {items.map(product => (
                            <li className="uk-padding-small vehicle_products" key={product.id}>
                                <ProductCard product={product} />
                            </li>
                        ))}
                    </ul>
                </div>
                {hasMore && (
                    <div className="uk-container uk-text-center uk-margin-top">
                        <Button
                            onClick={() => fetchPage(items.length)}
                            type="button"
                            modifier="primary"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Lädt…' : 'Mehr laden'}
                        </Button>
                    </div>
                )}
            </div>
        </section>
    );
}

export default VehicleSelectionProducts;